import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';

@Injectable({
  providedIn: 'root'
})
export class ApiSubscriptionsService {

  constructor(
    private apiBasic: ApiBasicService
  ) { }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
   getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'subscriptions');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName: string): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  edit(id: string): Observable<Res> {

    return this.apiBasic.edit('uroles_in_orgs', id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('uroles_in_orgs', params);
  }

 /**
 * 
 * @param params any
 * @returns Observable<Res>
 */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('uroles_in_orgs', params);
  }
  /**
   * 
   */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('uroles_in_orgs', params);
  }
}
